import styled from 'styled-components';

export const StyledBackButton = styled.div<{ $hasModalTitle?: boolean }>`
    display: none;
    @media (max-width: 768px) {
        display: flex;
        z-index: 1;
        ${(p) =>
        p.$hasModalTitle? `
            position: relative;
            width: fit-content;
            margin-top: -48px;
            margin-left: 12px;
            height: 48px;
            align-items: center;
        `
            : `
            position: absolute;
            top: 12px;
            left: 12px;
        `}
    }
`;

